export default __webpack_public_path__ + "static/media/laptop-with-check.7a887d15.svg";